module.exports = __webpack_public_path__ + "img/station-map.ddeb497a.png";